"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'nav.avatar.fallback': 'Avatar',
    'nav.avatar.alt': 'Avatar',
    'nav.avatar.loading': 'Cargando Avatar...',
};
